import { render, staticRenderFns } from "./GalleryTotalItems.vue?vue&type=template&id=62b7b51a&scoped=true&"
import script from "./GalleryTotalItems.vue?vue&type=script&lang=ts&"
export * from "./GalleryTotalItems.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryTotalItems.vue?vue&type=style&index=0&id=62b7b51a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7b51a",
  null
  
)

export default component.exports